export const MARKETPLACE = "/marketplace-new";
export const FIND_BRAND = "/site/nuordermarketplace";
